"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _echarts = _interopRequireDefault(require("@/lib/echarts"));

var _resize = _interopRequireDefault(require("./mixins/resize"));

//
//
//
//
var _default = {
  mixins: [_resize.default],
  props: {
    className: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "300px"
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    },
    chartLabel: {
      type: Array,
      required: true
    },
    isPercent: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      chart: null
    };
  },
  computed: {
    staticLabels: function staticLabels() {
      return [this.$t("dashboard.sun"), this.$t("dashboard.mon"), this.$t("dashboard.tue"), this.$t("dashboard.wed"), this.$t("dashboard.thu"), this.$t("dashboard.fri"), this.$t("dashboard.sat")];
    },
    labels: function labels() {
      var date = new Date();
      var index = date.getDay();
      return this.staticLabels.slice(index).concat(this.staticLabels.slice(0, index));
    },
    locale: function locale() {
      return this.$i18n.locale;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.initChart();
    });
  },
  watch: {
    locale: function locale(_locale) {
      this.initChart();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }

    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart: function initChart() {
      this.chart = _echarts.default.init(this.$el, "macarons");
      this.chart.clear();
      this.setOptions(this.chartData);
    },
    setOptions: function setOptions(rateSuccessForSevenDays) {
      //最近七天提交成功率和回执成功率
      this.chart.setOption({
        xAxis: {
          data: this.chartLabel,
          boundaryGap: false,
          axisTick: {
            show: false
          },
          //background x-line
          splitLine: {
            show: false
          }
        },
        grid: {
          left: 5,
          right: 30,
          bottom: 20,
          top: 30,
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          },
          //滑鼠移動到chart顯示的數值
          // formatter: `{b0} <br /> ${this.$t("dashboard.rateSuccess")} : {c0}% <br /> ${this.$t("dashboard.receiptSuccess")} : {c1}%`,
          formatter: "{b0} <br /> ".concat(this.$t("dashboard.payAmount"), " : {c0} USD"),
          padding: [5, 10]
        },
        yAxis: {
          //更改chart 左邊上下限的數值(min and max)
          min: 0,
          // max: 100,
          axisTick: {
            show: false
          },
          axisLabel: {
            formatter: '{value}'
          },
          //background y-line
          splitLine: {
            show: false
          }
        },
        legend: {
          data: [// this.$t("dashboard.rateSuccessForSevenDays"),
            // this.$t("dashboard.receiptSuccessForSevenDays")
          ]
        },
        series: [{
          name: this.$t("dashboard.rateSuccessForSevenDays"),
          itemStyle: {
            normal: {
              color: "#FF005A",
              lineStyle: {
                color: "#FF005A",
                width: 2
              }
            }
          },
          smooth: false,
          type: "line",
          data: rateSuccessForSevenDays,
          animationDuration: 2800,
          animationEasing: "cubicInOut",
          symbolSize: 10
        }]
      });
    }
  }
};
exports.default = _default;